export default __webpack_public_path__ + "static/media/slider-2.9ee6cae9.jpg";